import { render, staticRenderFns } from "./DepotItem.vue?vue&type=template&id=0147b0c9&"
import script from "./DepotItem.vue?vue&type=script&lang=js&"
export * from "./DepotItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports